import React, { useContext, useEffect } from "react";
import { StateContext, actions } from "../state/index";
import { logger } from "../utils/logging";
import { LOGGING } from "../utils/enums";
import bowser from "bowser";
import googleChromeIcon from "../assets/images/sync/google-chrome-icon.png";
import mozillaFirefoxIcon from "../assets/images/sync/mozilla-firefox-icon.png";
import microsoftEdgeIcon from "../assets/images/sync/microsoft-edge-icon.jpg";
import appleSafariIcon from '../assets/images/sync/mac-safari-icon.png';

export const CheckBrowserCompatibility = () => {
  const [{configuration, payment}, dispatch] = useContext(StateContext); // eslint-disable-line no-empty-pattern
  useEffect(() => {
    const browser = bowser.getParser(window.navigator.userAgent);
    // >0.2%, not dead, not op_mini all (https://browserl.ist/?q=%3E0.2%25%2C+not+dead%2C+not+op_mini+all)
    const isValidBrowser = browser.satisfies({
      chrome: ">=49",
      firefox: ">=68",
      safari: ">=5.1",
      edge: ">=17",
      opera: ">=63"
    });

    if (!isValidBrowser && false) {
      const browserDetails = browser.getBrowser();
      logger({
        event: LOGGING.EVENTS.UNSUPPORTED_BROWSER,
        browserDetails,
        programId: payment.programId,
        programName: configuration.programName
      });

      dispatch(
        actions.modals.pushModal(
          <div className="unsupported-browser-content">
            <p>
              It looks like you may be using an outdated or unsupported browser
              ({browserDetails.name} - Version {browserDetails.version}). If you
              experience any issues using this page, please try using an updated
              version of a modern web browser such as{" "}
              <a
                className="browser-link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.google.com/chrome/"
              >
                Google Chrome{" "}
                <img className="browser-icon" src={googleChromeIcon} alt="" />
              </a>
              ,{" "}
              <a
                className="browser-link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.mozilla.org/en-US/firefox/new/"
              >
                Mozilla Firefox{" "}
                <img className="browser-icon" src={mozillaFirefoxIcon} alt="" />
              </a>
              ,{" "}
              <a
                className="browser-link"
                rel="noopener noreferrer"
                href="https://www.microsoft.com/en-us/edge"
              >
                Microsoft Edge{" "}
                <img className="browser-icon" src={microsoftEdgeIcon} alt="" />
              </a>
              , or{" "}
              <a
                className="browser-link"
                rel="noopener noreferrer"
                href="https://www.microsoft.com/en-us/edge"
              >
                Apple Safari{" "}
                <img className="browser-icon" src={appleSafariIcon} alt="" />
              </a>
              .
            </p>
            <div className="close-button-container">
              <button
                onClick={() => dispatch(actions.modals.popModal())}
                className="close-button"
              >
                &times;
              </button>
            </div>
          </div>,
          {
            className: "unsupported-browser"
          }
        )
      );
    }
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default CheckBrowserCompatibility;
